import { message } from "antd";
import {
  EVENTS_NEWS_REQUEST,
  EVENTS_NEWS_SUCCESS,
  EVENTS_NEWS_FAIL,
  CREATE_EVENTS_NEWS_REQUEST,
  CREATE_EVENTS_NEWS_SUCCESS,
  CREATE_EVENTS_NEWS_FAIL,
  UPDATE_EVENTS_NEWS_REQUEST,
  UPDATE_EVENTS_NEWS_SUCCESS,
  UPDATE_EVENTS_NEWS_FAIL,
  DELETE_EVENTS_NEWS_REQUEST,
  DELETE_EVENTS_NEWS_SUCCESS,
  DELETE_EVENTS_NEWS_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/eventsAndNewsConstants";
import axios from "../../../axiosInstance";

// Fetch all Events & News 
export const getEventsNews = () => async (dispatch) => {
  try {
    dispatch({ type: EVENTS_NEWS_REQUEST });

    const { data } = await axios.get(
      "/api/v1/events-news/admin-get-events-news"
    );

    dispatch({ type: EVENTS_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EVENTS_NEWS_FAIL, payload: error.response.data.message });
  }
};

// Create new Events & News 
export const createEventNews = (eventData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EVENTS_NEWS_REQUEST });
    const { data } = await axios.post(
      "/api/v1/events-news/admin-create-events-news",
      eventData,
    );
 
    if (data?.success === true) {
      dispatch({ type: CREATE_EVENTS_NEWS_SUCCESS, payload: data });
      message.success(data?.message || "Events & News added successfully");
    } else {
      throw new Error(data?.message || "Failed to added");
    }
  } catch (error) {
    dispatch({
      type: CREATE_EVENTS_NEWS_FAIL,
      payload: error?.response?.data?.message ||  "Failed to add events & news"
    });
    message.error(
      error?.response?.data?.message || "Failed to add events & news"
    );
  }
};

// Update Events & News 
export const updateEventNews = (id, updatedData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EVENTS_NEWS_REQUEST });
    const { data } = await axios.put(
      `/api/v1/events-news/admin-update-events-news`,
      {
        data: { id, updatedData },
      }
    );
    if (data?.success === true) {
      dispatch({ type: UPDATE_EVENTS_NEWS_SUCCESS, payload: data });
      message.success(data?.message || "Events & News Update successfully");
    } else {
      throw new Error(data?.message || "Failed to update");
    }
  } catch (error) {
    dispatch({
      type: UPDATE_EVENTS_NEWS_FAIL,
      payload:
        error?.response?.data?.message || "Failed to delete events & news",
    });
    message.error(
      error?.response?.data?.message || "Failed to delete events & news"
    );
  }
};

// Delete Events & News 
export const deleteEventNews = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EVENTS_NEWS_REQUEST });
    const response = await axios.delete(
      `/api/v1/events-news/admin-delete-events-news`,
      {
        data: { id },
      }
    );
    if (response?.data?.success === true) {
      dispatch({ type: DELETE_EVENTS_NEWS_SUCCESS, payload: id });
      message.success(response?.data?.message || "Event deleted successfully");
    } else {
      throw new Error(response?.data?.message || "Failed to delete");
    }
  } catch (error) {
    dispatch({
      type: DELETE_EVENTS_NEWS_FAIL,
      payload:
        error?.response?.data?.message || "Failed to delete events & news",
    });
    message.error(
      error?.response?.data?.message || "Failed to delete events & news"
    );
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
